import { GiftCardCharm, GiftCardOrder } from 'api/types/giftCard/giftCard';
import { DateType } from 'shared/types/dates';

export const formatDate = (date: DateType) => {
  if (!date) return '';
  const mm = date.getMonth() + 1;
  const dd = date.getDate();
  const yy = date.getFullYear();
  return `${yy}-${mm}-${dd}`;
};

const joinCharms = (charms: GiftCardCharm[] | null | undefined, pick: (charm: GiftCardCharm) => string | number) =>
  charms?.length ? charms.map(pick).join('; ') : undefined;

// The export sheet gets one column per charm attribute, because a nested array would be written as "[object Object]".
export const flattenOrderForExport = ({ charms, ...order }: GiftCardOrder) => ({
  ...order,
  charmNames: joinCharms(charms, (charm) => charm.name),
  charmQuantities: joinCharms(charms, (charm) => charm.quantity),
  charmFees: joinCharms(charms, (charm) => charm.fee),
  charmsTotalFee: charms?.length ? charms.reduce((sum, charm) => sum + charm.fee * charm.quantity, 0) : undefined,
});

// Unlike `??`, also replaces empty/blank strings while keeping valid zeros.
export const displayOrPlaceholder = (value: string | number | null | undefined) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '') ? '--' : value;
